import React from "react";
import { motion } from "framer-motion";
const STATS = [{
  value: "+300",
  label: "Protocolos y herramientas clínicas"
}, {
  value: "+1.200",
  label: "Odontólogos de habla hispana"
}, {
  value: "+2.400",
  label: "Horas de incertidumbre reducidas"
}, {
  value: "97%",
  label: "Se sienten más seguros al planificar"
}];
export function Stats() {
  return <section className="w-full border-y border-gray-100 bg-white px-4 py-10" data-id="element-222" data-mp="2nyv5utfamwby">
      <p className="mb-6 text-center text-sm font-semibold text-gray-500" data-id="element-223" data-mp="296uojkkwzxdt">
        Más de <span className="font-bold text-[var(--brand)]" data-id="element-224" data-mp="2dznrq40qixns">1.200 odontólogos</span> ya utilizan Protocolo Clínica Segura™
      </p>
      <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-4" data-id="element-225" data-mp="205czvdtfyndi">
        {STATS.map((s, i) => <motion.div key={s.label} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.08
      }} className="text-center" data-id="element-226" data-mp="1q99wk4musioz" data-mpi={i}>
            <div className="font-serif-display text-3xl font-extrabold text-[var(--brand)] sm:text-4xl" data-id="element-227" data-mp="53wwwrtxi2gr">
              {s.value}
            </div>
            <div className="mx-auto mt-1 max-w-[140px] text-xs font-medium uppercase leading-tight tracking-wide text-gray-500" data-id="element-228" data-mp="e6xyqgbrh7em">
              {s.label}
            </div>
          </motion.div>)}
      </div>
    </section>;
}